{
  "confirmationNumber": "หมายเลขยืนยัน {number}",
  "dateTimeRange": "{date} ตั้งแต่ {startTime} ถึง {endTime}"
}
